import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import { PAGES } from '~/constants';
import AppPlaceholder from '~/components/AppPlaceholder';
import PrivateRoute from '~/components/PrivateRoute';

const Editor = lazy(() => import('~/pages/Editor'));
const Login = lazy(() => import('~/pages/Login'));
const Welcome = lazy(() => import('~/pages/Welcome'));

const Router = () => {
    const { search } = useLocation();

    return (
        <Routes>
            <Route path={PAGES.Login} element={<Login />} />
            <Route
                path={PAGES.Editor}
                element={
                    <PrivateRoute>
                        <Editor />
                    </PrivateRoute>
                }
            />
            <Route
                path={PAGES.Welcome}
                element={
                    <PrivateRoute>
                        <Welcome />
                    </PrivateRoute>
                }
            />
            <Route path="*" element={<Navigate to={`${PAGES.Welcome}${search}`} />} />
        </Routes>
    );
};
const App = () => (
    <BrowserRouter>
        <Suspense fallback={<AppPlaceholder />}>
            <Router />
        </Suspense>
    </BrowserRouter>
);

export default App;
